import React from 'react'
import { Card } from 'react-bootstrap'

const CardContent = (props) => {
  return (
    <>
        <Card className={props.cardClass}>
            <Card.Body className={props.bodyClass}>
                <Card.Title className={props.titleClass}> {props.title} </Card.Title>
                <Card.Subtitle className={props.subtitleClass}> {props.subtitle} </Card.Subtitle>
                <Card.Text className={props.textClass}> {props.text} </Card.Text>
                <div className={props.borderbottom}></div>
            </Card.Body>
        </Card>
    </>
  )
}

export default CardContent
